import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { ProductShowcaseSection } from './components/ProductShowcaseSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  useEffect(() => {
    // Manual Meta Pixel initialization
    const pixelId = '938923762400826';
    // Initialize fbq
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
    }
    // Load the pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    (window as any).clarity = (window as any).clarity || function (...args: any[]) {
      ;
      ((window as any).clarity.q = (window as any).clarity.q || []).push(args);
    };
    const clarityScript = document.createElement('script');
    clarityScript.async = true;
    clarityScript.src = 'https://www.clarity.ms/tag/wjdksgca9d';
    document.head.appendChild(clarityScript);
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) {
      ;
      (window as any).dataLayer.push(args);
    }
    ;
    (window as any).gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'GT-57VBPDG9');
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=GT-57VBPDG9';
    document.head.appendChild(gtagScript);
    return () => {
      // Cleanup scripts on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (clarityScript.parentNode) {
        clarityScript.parentNode.removeChild(clarityScript);
      }
      if (gtagScript.parentNode) {
        gtagScript.parentNode.removeChild(gtagScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-tcp-pure-black text-white font-body selection:bg-tcp-red selection:text-white overflow-x-hidden" data-id="element-0" data-mp="3gm63tp8sgt3c">
      <main data-id="element-1" data-mp="3bk72sm0iu89k">
        <HeroSection data-id="element-2" data-mp="3qb7hv9vrx0eo" />
        <WhoItsForSection data-id="element-3" data-mp="3qbpq74vpn52y" />
        <ProductShowcaseSection data-id="element-4" data-mp="3qbzf0p50r672" />
        <SocialProofSection data-id="element-5" data-mp="3qd0s0z5li2rf" />
        <FAQSection data-id="element-6" data-mp="3ljxw4kdcih82" />
        <FinalCTASection data-id="element-7" data-mp="3ljg1fs6c0b29" />
      </main>

      {/* Minimal Footer */}
      <footer className="bg-tcp-pure-black border-t-2 border-tcp-red py-12" data-id="element-8" data-mp="2xun4pthvxz6l">
        <div className="container mx-auto px-6 max-w-7xl flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-9" data-mp="2xsk46fj3wnnm">
          <div data-id="element-10" data-mp="18e19rkmjbok1">
            <h5 className="font-display text-xl font-bold text-white mb-1 text-center" data-id="element-11" data-mp="18dhpvydbqq3d">
              The Christmas Palace
            </h5>
            <p className="text-gray-500 text-sm" data-id="element-12" data-mp="1d5ssxa3d2s05">
              Premium Wholesale Décor • Founded 1992
            </p>
          </div>

          <div className="text-gray-500 text-sm" data-id="element-13" data-mp="13eexpeig0ect">
            <a href="#" className="hover:text-tcp-red transition-colors duration-300" data-id="element-14" data-mp="13f7ubmnotnh8">
              wholesale.thechristmaspalace.com
            </a>
          </div>
        </div>
      </footer>
    </div>;
}